if (process.env.NODE_ENV === 'development') {
  var API_URL = 'http://0.0.0.0:8000';
} else {
  API_URL = '';
}

const API_KEY = process.env.REACT_APP_API_KEY;


export { API_URL, API_KEY };
